import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

function defaultRender(value) {
  if(typeof value === "boolean") { return String(value); }
  if(typeof value === "string") {
    if(!value) { return "None"; }
    if(value.startsWith("http")) { return <a href={value} rel="noreferrer" target="_blank">{value}</a>; }
  }

  return value;
}

export default function AdminList({actions, columns, name, path, plural = null, singular = null}) {
  const [records, setRecords] = useState([]);
  const pluralName = plural || `${name}s`;
  const singularName = singular || name;

  useEffect(() => {
    actions.list().then((data) => setRecords(data.records));
  }, []);

  return (
    <div className="container">
      <h1>{pluralName}</h1>
      {actions.new && <Link className="btn btn-primary" to={`${path}/new`}>New {singularName}</Link>}
      <table>
        <thead>
          <tr>
            {columns.map(({label}) => <th key={label}>{label}</th>)}
            {actions.edit && <th aria-label="Actions" />}
          </tr>
        </thead>
        <tbody>
          {records.map((record) => (
            <tr key={record.id}>
              {columns.map(({key, render}) => (
                <td key={key}>{render ? render(record) : defaultRender(record[key])}</td>
              ))}
              {actions.edit && (
                <td>
                  <Link to={`${path}/${record.id}/edit`}>Edit</Link>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
